import { InjectionToken } from '@angular/core';
import { INavigatorService } from './navigator-service.interface';

export const NAVIGATOR_SERVICE = new InjectionToken<INavigatorService>(
  'NAVIGATOR_SERVICE'
);
